var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmnrLong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 628.9 243.1",
    style: {
      enableBackground: "new 0 0 628.9 243.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{enable-background:new    ;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#E63946;}\r\n\t.st3{fill:#1D3557;}\r\n\t.st4{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st5{fill:#E63946;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st6{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.2,150.6v22h-63V72.5h62.3v22h-39.4v16.6h35.8v21.8h-35.8v17.8H323.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.3,172.7h-22.9v-58.3l-25.9,42.5h-2.6L359,114.4v58.3h-22.9V72.5H359l27.2,44.5l27.2-44.5h22.9V172.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M532.2,72.5v100.2H515l-38.7-54.4v54.4h-22.9V72.5h17.2l38.7,54.4V72.5H532.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M583.2,139.8h-10.9v32.9h-22.9V72.5h40.1c19,0,34.4,15.3,34.4,34.4c0,12.3-7.4,23.5-18.5,29.1l21.3,36.8 h-24.6L583.2,139.8z M572.3,119.7h17.2c6.3,0,11.5-5.6,11.5-12.9s-5.2-12.9-11.5-12.9h-17.2V119.7z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M155.4,15.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M214.4,7.5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.2,242.6c0-0.9,2.8-33.9,13.8-39.6c11.1-5.6,18.5-9,18.5-9c4-1.8,5-6,2.2-9.4c-3.4-3.6-8.1-5.8-13-5.9 l-20.9,0.5c-5.2-0.1-10.2-1.5-14.7-4.1l-16-10.2c-4.3-3-8-6.7-11-11l-5.3-8.2c-2.6-4.5-4.1-9.6-4.3-14.7v-28.8 c-0.1-4-1.4-8-3.7-11.3c-2-2.6-5.3-3.9-7.4-2.8s-5.1,4.4-6.9,7.5s-6.3,7.3-10.2,9.4c-4,2.2-8.2,4.1-12.5,5.7c-3,1-8.4,2.5-12,3.3 s-3.1,2.9,0.9,4.6l4.7,2.1c4.9,2,10,3.6,15.2,4.6l0.8,0.1c4.8,1.1,8.7,4.4,10.6,8.9c0.5,1.2,0.8,2.5,1,3.8c0,1,1,10,1,10 c0.8,5.1,2.9,10,6,14.1l0.8,0.9c3.4,4,7.1,7.8,11,11.4l2.9,2.6c4,3.4,8.4,6.4,13.1,8.8l5,2.4c4,1.9,9.9,5,13.2,6.8 s6.6,6.9,7.3,11.2l1.1,6.8c0.7,4.3,2.2,11.4,3.3,15.6l1.6,6.2C103.5,239.1,105.2,242.6,106.2,242.6L106.2,242.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M106.2,242.6c0-0.9,2.8-33.9,13.8-39.6c11.1-5.6,18.5-9,18.5-9c4-1.8,5-6,2.2-9.4c-3.4-3.6-8.1-5.8-13-5.9 l-20.9,0.5c-5.2-0.1-10.2-1.5-14.7-4.1l-16-10.2c-4.3-3-8-6.7-11-11l-5.3-8.2c-2.6-4.5-4.1-9.6-4.3-14.7v-28.8 c-0.1-4-1.4-8-3.7-11.3c-2-2.6-5.3-3.9-7.4-2.8s-5.1,4.4-6.9,7.5s-6.3,7.3-10.2,9.4c-4,2.2-8.2,4.1-12.5,5.7c-3,1-8.4,2.5-12,3.3 s-3.1,2.9,0.9,4.6l4.7,2.1c4.9,2,10,3.6,15.2,4.6l0.8,0.1c4.8,1.1,8.7,4.4,10.6,8.9c0.5,1.2,0.8,2.5,1,3.8c0,1,1,10,1,10 c0.8,5.1,2.9,10,6,14.1l0.8,0.9c3.4,4,7.1,7.8,11,11.4l2.9,2.6c4,3.4,8.4,6.4,13.1,8.8l5,2.4c4,1.9,9.9,5,13.2,6.8 s6.6,6.9,7.3,11.2l1.1,6.8c0.7,4.3,2.2,11.4,3.3,15.6l1.6,6.2C103.5,239.1,105.2,242.6,106.2,242.6L106.2,242.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.8,152.3c-2.1-1.7-3.9-4-5.1-6.4c-1-2.3-1.9-7.8-1.9-12.1v-16.2c-0.1-5.3-0.8-10.6-2-15.7l-1.5-5.7 c-1.5-5-4.2-9.5-7.9-13.2l-4-3.8c-4-3.4-8.6-6-13.6-7.5l-12.2-3.3c-5.2-1.3-10.5-2.1-15.8-2.3l-8.9-0.4 c-4.4-0.2-9.4-0.3-11.2-0.3s-5.5-2.5-8.3-5.5s-3.6-6.8-1.8-8.3s6.6-4.2,10.6-5.9l2.8-1.2c4-1.7,8.8-3.1,10.6-3.1s3.8-3.6,4.5-7.9 l1.2-7.2c0.7-4.4,1.9-11.4,2.6-15.8l0.1-0.8c0.7-4.3,2.3-8.3,3.6-8.8s3,2.6,3.8,6.9l5.3,27.6c1.2,4.8,4.5,8.7,9,10.7l9,3.5 c4.9,2,9.4,4.7,13.6,8l11.8,10c3.9,3.5,7,7.8,9.3,12.5l3.7,8.4c2,4.8,3.7,9.7,5.1,14.7c1,4,4.8,8.4,8.3,9.7 c4.7,1.6,9.5,2.8,14.3,3.8l8.3,1.6c4.3,0.8,7.9,3,7.9,4.7s-2.9,4.3-6.5,5.5c-3.6,1.3-9.9,3.4-14,4.8l-1.4,0.5 c-4.8,1.9-9.1,5-12.3,9l-3.4,4.6c-2.6,3.5-6,6.6-7.5,6.9S175.6,153.5,173.8,152.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M173.8,152.3c-2.1-1.7-3.9-4-5.1-6.4c-1-2.3-1.9-7.8-1.9-12.1v-16.2c-0.1-5.3-0.8-10.6-2-15.7l-1.5-5.7 c-1.5-5-4.2-9.5-7.9-13.2l-4-3.8c-4-3.4-8.6-6-13.6-7.5l-12.2-3.3c-5.2-1.3-10.5-2.1-15.8-2.3l-8.9-0.4 c-4.4-0.2-9.4-0.3-11.2-0.3s-5.5-2.5-8.3-5.5s-3.6-6.8-1.8-8.3s6.6-4.2,10.6-5.9l2.8-1.2c4-1.7,8.8-3.1,10.6-3.1s3.8-3.6,4.5-7.9 l1.2-7.2c0.7-4.4,1.9-11.4,2.6-15.8l0.1-0.8c0.7-4.3,2.3-8.3,3.6-8.8s3,2.6,3.8,6.9l5.3,27.6c1.2,4.8,4.5,8.7,9,10.7l9,3.5 c4.9,2,9.4,4.7,13.6,8l11.8,10c3.9,3.5,7,7.8,9.3,12.5l3.7,8.4c2,4.8,3.7,9.7,5.1,14.7c1,4,4.8,8.4,8.3,9.7 c4.7,1.6,9.5,2.8,14.3,3.8l8.3,1.6c4.3,0.8,7.9,3,7.9,4.7s-2.9,4.3-6.5,5.5c-3.6,1.3-9.9,3.4-14,4.8l-1.4,0.5 c-4.8,1.9-9.1,5-12.3,9l-3.4,4.6c-2.6,3.5-6,6.6-7.5,6.9S175.6,153.5,173.8,152.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "95.9,133 43.8,44.4 125.4,110.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "126,111.7 177.8,201.4 96,133.7  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmnrLong);
export default __webpack_public_path__ + "static/media/emnr_long.f8183767b572b83a025ee0ff6bb9bf93.svg";
export { ForwardRef as ReactComponent };